/* ==========================================================================
   Vaja Landing v2 — único JS de las secciones vaja-* (~1 KB gzip, sin dependencias)
   Se carga como type="module": el navegador lo ejecuta una sola vez aunque
   varias secciones lo incluyan, y siempre en diferido.
   1) Videos: no descargan nada hasta después del load; luego solo el de la
      resolución que corresponde (desktop o mobile), con una pantalla de
      anticipación para que arranquen con buffer. Se pausan al salir del
      viewport. Se reproducen siempre, también con "reducir movimiento"
      activado (igual que GemPages); solo se omiten con ahorro de datos
      (Save-Data): ahí queda el póster.
   2) Flechas de los carruseles scroll-snap.
   3) Cierra los selectores de modelo al hacer clic afuera o con Escape.
   ========================================================================== */

const mobile = window.matchMedia('(max-width: 767px)');
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const saveData = !!(navigator.connection && navigator.connection.saveData);

/* ---------- 1. Videos ---------- */
/* Dos etapas: el archivo empieza a bajar cuando el video está a ~1 pantalla
   de distancia (así ya tiene buffer al llegar) y se reproduce/pausa solo
   cuando está realmente visible. */
let nearIO = null;
let viewIO = null;
let started = false;

function load(video) {
  if (video.dataset.loaded) return;
  const src = (mobile.matches && video.dataset.srcMobile) || video.dataset.src;
  if (!src) return;
  video.muted = true;
  video.preload = 'auto';
  video.src = src;
  video.dataset.loaded = '1';
  video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
}

function play(video) {
  load(video);
  const p = video.play();
  if (p && p.catch) p.catch(() => {});
}

function observeVideos(root = document) {
  if (saveData || !('IntersectionObserver' in window)) return;
  nearIO = nearIO || new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        load(entry.target);
        nearIO.unobserve(entry.target);
      }
    }
  }, { rootMargin: '100% 0px' });
  viewIO = viewIO || new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) play(entry.target);
      else if (entry.target.dataset.loaded) entry.target.pause();
    }
  }, { threshold: 0.15 });
  root.querySelectorAll('video[data-vj-video]:not([data-observed])').forEach((v) => {
    v.dataset.observed = '1';
    nearIO.observe(v);
    viewIO.observe(v);
  });
}

function start() {
  if (started) return;
  started = true;
  observeVideos();
}
// El póster es el LCP: los videos esperan al load (o 2,5 s como máximo).
if (document.readyState === 'complete') start();
else {
  window.addEventListener('load', start, { once: true });
  setTimeout(start, 2500);
}

/* ---------- 2. Carruseles ---------- */
function updateArrows(track) {
  const slider = track.closest('[data-vj-slider]');
  if (!slider) return;
  const prev = slider.querySelector('[data-vj-slide="prev"]');
  const next = slider.querySelector('[data-vj-slide="next"]');
  const max = track.scrollWidth - track.clientWidth - 2;
  if (prev) prev.disabled = track.scrollLeft <= 2;
  if (next) next.disabled = track.scrollLeft >= max;
}

function initSliders(root = document) {
  root.querySelectorAll('[data-vj-track]:not([data-ready])').forEach((track) => {
    track.dataset.ready = '1';
    let raf = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => updateArrows(track));
    }, { passive: true });
    updateArrows(track);
  });
}
initSliders();

document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-vj-slide]');
  if (btn) {
    const track = btn.closest('[data-vj-slider]').querySelector('[data-vj-track]');
    const dir = btn.dataset.vjSlide === 'next' ? 1 : -1;
    track.scrollBy({ left: dir * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    return;
  }
  /* ---------- 3. Cerrar selectores abiertos ---------- */
  document.querySelectorAll('.vj-dd[open]').forEach((d) => {
    if (!d.contains(e.target)) d.removeAttribute('open');
  });
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('.vj-dd[open]').forEach((d) => {
    d.removeAttribute('open');
    const summary = d.querySelector('summary');
    if (summary && d.contains(document.activeElement)) summary.focus();
  });
});

/* Editor de temas: re-inicializar secciones recargadas */
document.addEventListener('shopify:section:load', (e) => {
  initSliders(e.target);
  if (started) observeVideos(e.target);
});
